import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Configuration } from '@ui/shared/util-api';
import { BehaviorSubject } from 'rxjs';

const imageLoadingGracePeriod = 100;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-image',
    templateUrl: './detail-image.component.html',
    styleUrls: ['./detail-image.component.scss'],
    standalone: false,
})
export class DetailImageComponent implements OnChanges {
    @Input({ required: true })
    public imagePath?: string;

    @Input()
    public placeholderPath?: string | undefined;

    @Input()
    public altText = '';

    @Input()
    public showPlaceholderImmediately = false;

    public basePath: string | undefined;

    public shouldContainImage$ = new BehaviorSubject<boolean>(false);
    public isImageLoaded$ = new BehaviorSubject<boolean>(false);
    public isImageDelayed$ = new BehaviorSubject<boolean>(false);

    constructor(
        @Inject(Configuration) _configuration: Configuration,
    ) {
        this.basePath = _configuration.basePath;
    }

    public ngOnChanges(changes: SimpleChanges): void {

        /*
         * While the image loads, display a placeholder.
         * If the image takes a certain time to load, display loading animation over the placeholder.
         * This is reset every time the image changes.
         */
        if (changes['imagePath']) {
            this.isImageDelayed$.next(false);
            this.isImageLoaded$.next(false);

            setTimeout(
                () => {
                    if (!this.isImageLoaded$.value) {
                        this.isImageDelayed$.next(true);
                    }
                },
                imageLoadingGracePeriod,
            );
        }
    }

    public onImageLoaded(event: Event): void {
        this._setImageDimensions(event);

        this.isImageLoaded$.next(true);
    }

    private _setImageDimensions(event: Event): void {
        const landscapeFactor = 1;
        const tooWideFactor = 2;

        const image = event.target as HTMLImageElement | undefined;

        if (image) {
            const dimensionalFactor = image.naturalWidth / image.naturalHeight;

            if (dimensionalFactor <= landscapeFactor || dimensionalFactor > tooWideFactor) {
                this.shouldContainImage$.next(true);
            }
        }
    }
}
